/*
	Form to grab valid email - calls 'emailHandler' when a valid email has been entered
*/
import React from 'react'
import PropTypes from 'prop-types'
import { Button, TextField } from '@material-ui/core'
import validateEmail from '../utilities/validateEmail'
import styles from './EmailInputAndValidation.icss'

class EmailInputAndValidation extends React.Component {
	constructor(props) {
		super(props)

		this.state = { email: props.email }

		this.handleEmailChange = this.handleEmailChange.bind(this)
		this.handleEmailSubmit = this.handleEmailSubmit.bind(this)
		this.validateEmail = this.validateEmail.bind(this)
	}

	validateEmail(email) {
		const emailValidationError = !validateEmail(email)
		this.setState({ emailValidationError })
		return !emailValidationError
	}

	handleEmailChange(e) {
		const email = e.target.value
		this.setState({ email, hasSubmitted: false })
		this.validateEmail(email)
	}

	handleEmailSubmit() {
		this.setState({ hasAttemptedToSubmit: true })
		if (this.validateEmail(this.state.email)) {
			const hasSubmitted = true
			this.setState({ hasSubmitted })
			this.props.emailHandler(this.state.email)
		}
	}

	render() {
		return (
			<section className={`${styles.container} ${styles.emailSurround}`}>
				<div className={styles.emailField}>
					<TextField
						name="email"
						type="email"
						fullWidth
						label={this.props.label}
						value={this.state.email}
						onChange={this.handleEmailChange}
					/>
				</div>
				{this.state.emailValidationError && this.state.hasAttemptedToSubmit && (
					<div>
						<span className={styles.validationError}>{this.context.translate('Please enter a valid email')}</span>
					</div>
				)}
				<Button
					onClick={this.handleEmailSubmit}
					classes={{ root: styles.button + (!this.state.hasSubmitted && !this.state.emailValidationError && this.state.email !== '' ? ` ${styles.buttonValid}` : ''), label: styles.label }}
					disabled={this.state.hasSubmitted}
				>
					{this.props.buttonText}
				</Button>
			</section>
		)
	}
}

EmailInputAndValidation.contextTypes = {
	translate: PropTypes.func
}

EmailInputAndValidation.propTypes = {
	emailHandler: PropTypes.func.isRequired,
	buttonText: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	email: PropTypes.string
}

EmailInputAndValidation.defaultProps = {
	email: ''
}

export default EmailInputAndValidation



// WEBPACK FOOTER //
// ./src/components/EmailInputAndValidation.jsx